import { CHINESE_KEYBOARD_NAME } from '../Custom/Chinese/constants';

export const traditionalPinyinLayout = {
  name: CHINESE_KEYBOARD_NAME.PINYIN,
  layout: {
    default: [
      '· 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'q w e r t y u i o p 「 」 、',
      'a s d f g h j k l ; \' {enter}',
      '{shift} z x c v b n m , 。 / {shift}',
      '{special} {space} {@}',
    ],
    shift: [
      '~ ! @ # $ % …… & * ( ) —— + {bksp}',
      'Q W E R T Y U I O P 『 』 |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M 《 》 ? {shift}',
      '{special} {space} {@}',
    ],
    special: [
      '. 1 2 3 4 5 6 7 8 9 0 < > {bksp}',
      '[ ] { } # % ^ * + = \\ | _',
      '- / : ; ( ) $ & @ \' ¥ {enter}',
      '… 。 , 、 ? ! ~ “ ” 「 」',
      '{default} {space} {@}',
    ],
  },
};

export const simplifyPinyinLayout = {
  name: CHINESE_KEYBOARD_NAME.PINYIN,
  layout: {
    default: [
      '· 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'q w e r t y u i o p 【 】 、',
      'a s d f g h j k l ; \' {enter}',
      '{shift} z x c v b n m , 。 / {shift}',
      '{special} {space} {@}',
    ],
    shift: [
      '~ ! @ # ¥ % …… & * ( ) —— + {bksp}',
      'Q W E R T Y U I O P 「 」 |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M 《 》 ? {shift}',
      '{special} {space} {@}',
    ],
    special: [
      '. 1 2 3 4 5 6 7 8 9 0 < > {bksp}',
      '[ ] { } # % ^ * + = \\ | _',
      '- / : ; ( ) ¥ & @ \' $ {enter}',
      '… 。 , 、 ? ! ~ “ ” 「 」',
      '{default} {space} {@}',
    ],
  },
};
